<template>
  <section class="app-ecommerce-details ">

    <!-- <b-row class="pb-2 d-flex justify-content-end mr-1">
        <b-col cols="auto" class="text-right align-self-end">
          <p><strong>Total de Pedidos :</strong> {{ totalUnidades }}</p>
          <p><strong>Total Valor : </strong> R$ {{ totalValor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</p>
        </b-col>
      </b-row> -->
    <div v-if="getIsLoadingReferencia" class="loading-indicator">
      <b-spinner small type="grow" class="mr-2"></b-spinner>
      Carregando referências...
    </div>
    <div v-if="getIsLoadingReferenciaRestante" class="loading-indicator">
      <b-spinner small type="grow" class="mr-2"></b-spinner>
      Carregando mais itens...
    </div>
    <b-row class="ml-1 my-2" v-for="product in visibleProducts" :key="product.item_id">

      <b-col cols="1" class="imagens-container pr-0 mt-1">
        <div class="imagens-item">
          <div v-if="product.imagens.length > 0" v-for="(img, index) in product.imagens.slice(0, 5)" :key="index">
            <div class="rounded imagens-item-img">
              <b-img
                :src="img.caminho ? img.caminho : imagemPadrao"
                :alt="`${product.item_name}-${product.item_id}`" class="img-fluid"
                @click="product.item_img_princial = img.caminho"
                @mouseover="product.item_img_princial = img.caminho" />
            </div>
          </div>
          <div v-if="product.imagens.length > 5"
            class="d-flex justify-content-center align-items-center bg-grey-1 rounded"
            style="border: 1px solid var(--primary); width: 50px; height: 50px;" @click="openGallery(product)">
            +{{ product.imagens.length - 5 }}
          </div>
        </div>
      </b-col>
      <b-col cols="12" sm="12" md="4" class="px-auto mt-1">
        <b-img
          :src="product.item_img_princial ? product.item_img_princial : imagemPadrao"
          :alt="`${product.item_name}-${product.item_id}`"
          style="max-height: 300px; width: auto; margin: 0 auto; display: block;"
          class="img-fluid" />
      </b-col>
      <b-col cols="12" md="7">
        <h4 class="font-medium-3">{{ product.referencia }} - {{ product.item_name }}</h4>
        <b-card-text class="item-company mb-0">
          <span>by </span>
          <b-link class="company-name">{{ product.item_marca }}</b-link>
        </b-card-text>
        <div class="ecommerce-details-item_price d-flex flex-wrap mt-1">
          <h4 class="item-item_price mr-1">R$ {{ product.item_price.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</h4>
        </div>

        <b-card-text v-if="hasValidEmbalagens(product)">Disponível - <span class="text-success">Em
            estoque</span></b-card-text>
        <!--                  <b-card-text>{{ product.item_caracteristicas }}</b-card-text>-->
        <div v-if="!hasValidEmbalagens(product)">

          <b-alert show variant="danger">
            Não há embalagens disponíveis
          </b-alert>
        </div>
        <div class="product-color-options"
          v-if="hasValidEmbalagens(product) && itemSelected !== null && product.item_id === itemSelected.item_id">
          <h6>EMBALAGEM</h6>
          <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;">
            <li v-for="embalagem in uniqueEmbalagens(getValidEmbalagens(product.embalagens))" :key="embalagem.descricao_embalagem">
              <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                :variant="formColor.embalagem === embalagem.descricao_embalagem ? 'primary' : 'outline-secondary'"
                size="sm" @click="selectEmbalagem(embalagem)">
                {{ embalagem.descricao_embalagem }}
              </b-button>
            </li>
          </ul>
          <hr class="my-1">
          <!-- Colors -->
          <div class="product-color-options">
            <h6>COR</h6>
            <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;">
              <li v-for="color in availableColors" :key="color.cdnCor" v-if="availableColors.length > 0">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="formColor.color === color.desCor ? 'primary' : 'outline-secondary'" size="sm"
                  @click="selectColor(color)">
                  {{ color.desCor }}
                </b-button>
              </li>
            </ul>
          </div>
          <!-- Sizes -->
          <hr class="my-1">
          <div class="product-color-options">
            <h6>TAMANHO</h6>
            <ul class="list-unstyled mb-0 scrollable-pills" style="display: flex; gap: 10px; flex-wrap: wrap;" v-if="availableSizes.length > 0">
              <li v-for="size in availableSizes" :key="size">
                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  :variant="formColor.tamanho === size ? 'primary' : 'outline-secondary'" size="sm"
                  @click="formColor.tamanho = size">
                  {{ size }}
                </b-button>
              </li>
            </ul>
          </div>

          <!-- Quantity -->
          <hr class="my-1">
          <div class="product-color-options">
            <h6>QUANTIDADE</h6>
            <b-form-group>
              <b-input-group style="max-width: 300px;">
                <b-form-input
                  v-model="formColor.quantidade"
                  type="number"
                  min="1"
                  placeholder="0"
                />
                <b-input-group-append>
                  <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary" @click="repeateAgain">
                    <feather-icon icon="PlusIcon" size="14" class="mr-50" />
                    Adicionar
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <!-- Selected Items -->
          <hr class="my-1">
          <div class="mx-1">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <h6 class="mb-0">ITENS ADICIONADOS</h6>
              <b-badge variant="light-primary" pill v-if="getFilteredItems(product.referencia).length">
                {{ getFilteredItems(product.referencia).length }}
              </b-badge>
            </div>

            <div class="selected-items-list" v-if="getFilteredItems(product.referencia).length > 0">
              <div class="d-flex flex-wrap" style="gap: 8px">
                <b-badge
                  v-for="(item, index) in getFilteredItems(product.referencia)"
                  :key="item.uniqueId || index"
                  variant="light-primary"
                  class="d-flex align-items-center px-2 py-1"
                  style="font-size: 0.85rem;"
                >
                  <span class="mr-1">{{ item.des_cor }} - {{ item.tamanho }} ({{ item.valor }})</span>
                  <feather-icon
                    icon="XIcon"
                    size="14"
                    class="cursor-pointer"
                    @click="removeItem(index, item)"
                  />
                </b-badge>
              </div>
            </div>
            <div v-else class="text-muted small font-italic">
              Nenhum item adicionado ainda.
            </div>
          </div>

        </div>
        <div v-else>
          <b-button variant="primary" @click="selecionarItem(product)">Selecionar</b-button>
        </div>
      </b-col>
    </b-row>
    <!-- <b-button v-if="hasMoreProducts" class="mt-3" @click="showMoreProducts" variant="outline-primary">
      Mostrar mais produtos
    </b-button>
    <b-button v-if="visibleCount > 3" class="mt-3 ml-2" @click="showLessProducts" variant="outline-secondary">
      Mostrar menos produtos
    </b-button> -->
    <b-modal id="modal-gallery-imagens" hide-footer hide-header
      style="height: 500px; width: 100%;background: transparent; border: none; padding: 0; margin: 0;"
      body-bg-variant="transparent">
      <swiper ref="refSwiperGallery" class="swiper-gallery gallery-top" :options="swiperOptions"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'">
        <swiper-slide v-for="(data, index) in itemSelected.imagens" :key="index">
          <b-img :src="data.caminho" fluid />
        </swiper-slide>

        <div slot="button-next" class="swiper-button-next swiper-button-white" />
        <div slot="button-prev" class="swiper-button-prev swiper-button-white" />
      </swiper>
    </b-modal>

  </section>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BImg, BCardText, BLink, BButton, BDropdown, BDropdownItem, BAlert, BFormGroup, BFormSpinbutton, BBadge, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';
import { ref } from '@vue/composition-api';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { mapGetters } from 'vuex';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import ScrollToTop from '@core/components/scroll-to-top/ScrollToTop.vue';
import Swal from 'sweetalert2';
import { IMAGEM_PADRAO } from '@/utils/imagemUrl';

export default {
  directives: {
    Ripple,
  },
  components: {
    ScrollToTop,
    BCard,
    SwiperSlide,
    Swiper,
    BCardBody,
    BRow,
    BCol,
    BImg,
    BCardText,
    BLink,
    BButton,
    BDropdown,
    BDropdownItem,
    BAlert,
    BFormGroup,
    BFormSpinbutton,
    BBadge,
    BInputGroup,
    BInputGroupAppend,
  },

  data() {
    return {
      imagemPadrao: IMAGEM_PADRAO,
      showColorSizeOptions: false,
      formColor: {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      },
      items: [],
      availableColors: [],
      availableSizes: [],
      isLoading: true,
      itemSelected: [{
        imagens: [],
      }],
      visibleCount: 3,
      swiperOptions: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5,
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 4,
        touchRatio: 0.2,
        slideToClickedSlide: true,
      },

    };
  },
  beforeDestroy() {
    this.$store.dispatch('intensPedido/setIsLoadingReferenciaRestante', false);
  },
  computed: {
    ...mapGetters({
      json: 'intensPedido/getjsonTelaNovaPedido',
    }),
    ...mapGetters('intensPedido', [
      'getIsLoadingReferencia',
      'getIsLoadingReferenciaRestante',

    ]),
    visibleProducts() {
      return this.json;
      // return this.json.slice(0, this.visibleCount);
    },
    hasMoreProducts() {
      // console.log(this.json.length, this.visibleCount)
      // return this.json.length > this.visibleCount;
      return false;
    },
  },
  mounted() {
    this.items = [];
    this.$root.$on('modal:opened', this.resetItems);
    this.$root.$on('item:removed', this.handleItemRemoved);
    this.$root.$on('subitem:removed', this.handleSubItemRemoved);

    this.$root.$on('modal:sync-items', this.syncWithStore);
  },
  beforeDestroy() {
    this.$root.$off('modal:opened');
    this.$root.$off('item:removed');
    this.$root.$off('subitem:removed');
    this.$root.$off('modal:sync-items');
  },
  methods: {
    hasValidEmbalagens(product) {
      return this.getValidEmbalagens(product?.embalagens || []).length > 0;
    },
    getValidEmbalagens(embalagens) {
      return (embalagens || []).filter((embalagem) => Array.isArray(embalagem?.grade?.dsHBIgrade?.ttHBIgrade)
          && embalagem.grade.dsHBIgrade.ttHBIgrade.length > 0);
    },
    syncWithStore() {
      this.itensTabela = (this.getlistarTabelaItens || []).flatMap((item) => (item.itens || []).map((subitem) => ({
        ...subitem,
        codMarca: item.CodMarca,
        familiaComercialId: item.CodReferencia,
        marca: item.DescricaoMarca,
        descricao_referencia: item.DescricaoReferencia,
        precoUnitario: subitem.precoUnitario,
        precoComImposto: subitem.precoComImposto,
        valorTotal: subitem.valorTotal,
        pedidoItemQuantidade: subitem.pedidoItemQuantidade,
        embalagem: subitem.embalagem,
        cdn_embalagem: subitem.cdn_embalagem,
        des_cor: subitem.des_cor,
        cdn_cor: subitem.cdncor,
        tamanho: subitem.desc_tamanho,
        item_id: subitem.itemId,
        nome: subitem.item_descricao,
        valor: subitem.pedidoItemQuantidade,
      })));
    },
    handleSubItemRemoved(data) {
      this.items = this.items.filter((item) => !(item.referencia === data.referencia
          && item.item_id === data.item_id
          && item.des_cor === data.des_cor
          && item.tamanho === data.tamanho));
    },
    handleItemRemoved(data) {
      this.items = this.items.filter((item) => item.referencia !== data.referencia);
    },
    resetItems() {
      this.items = [];
      this.formColor = {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      };
      this.availableColors = [];
      this.availableSizes = [];
    },
    openGallery(product) {
      this.itemSelected = product;
      this.$bvModal.show('modal-gallery-imagens');
    },
    uniqueEmbalagens(embalagens) {
      const seen = new Set();
      return embalagens.filter((embalagem) => {
        if (!seen.has(embalagem.descricao_embalagem)) {
          seen.add(embalagem.descricao_embalagem);
          return true;
        }
        return false;
      });
    },
    getFilteredItems(referencia) {
      return this.items.filter((item) => item.referencia === referencia);
    },
    showMoreProducts() {
      this.visibleCount += 3;

      if (this.json.length <= this.visibleCount && this.hasMoreProductsToLoad) {
        this.$store.dispatch('intensPedido/loadMoreItems');
      }
    },
    showLessProducts() {
      this.visibleCount = 3;
    },
    removeItem(index, item) {
      const idx = this.items.findIndex((i) => i.uniqueId === item.uniqueId);
      if (idx !== -1) {
        this.items.splice(idx, 1);
        this.$emit('update:grade', this.items);
        this.$emit('remove-item', item);
      }
    },
    getAvailableSizes(color) {
      const sizes = [];
      if (color.itemExtrapq) sizes.push('Extrapq');
      if (color.itemPequeno) sizes.push('Pequeno');
      if (color.itemMedio) sizes.push('Medio');
      if (color.itemGrande) sizes.push('Grande');
      if (color.itemExtraGd) sizes.push('ExtraGd');
      if (color.itemSuperGd) sizes.push('SuperGd');
      if (color.itemUltraGd) sizes.push('UltraGd');
      if (color.itemUnico) sizes.push('Unico');
      if (color.itemOutros) sizes.push('Outros');
      return sizes;
    },
    selectEmbalagem(embalagem) {
      this.formColor.embalagem = embalagem.descricao_embalagem;
      this.formColor.cdn_embalagem = embalagem.cdn_embalagem;

      if (embalagem.grade?.dsHBIgrade?.ttHBIgrade) {
        this.availableColors = embalagem.grade.dsHBIgrade.ttHBIgrade.map((item) => ({
          cdnCor: item.cdnCor,
          desCor: item.desCor,
          itemExtrapq: item.itemExtrapq,
          itemPequeno: item.itemPequeno,
          itemMedio: item.itemMedio,
          itemGrande: item.itemGrande,
          itemExtraGd: item.itemExtraGd,
          itemSuperGd: item.itemSuperGd,
          itemUltraGd: item.itemUltraGd,
          itemUnico: item.itemUnico,
          itemOutros: item.itemOutros,
        }));

        this.availableSizes = [];
        this.showColorSizeOptions = true;
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Cores não encontradas para esta embalagem',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });

        this.availableColors = [];
        this.availableSizes = [];
        this.showColorSizeOptions = false;

        this.formColor.color = '';
        this.formColor.tamanho = '';
        this.formColor.quantidade = 0;
      }
    },
    selectColor(color) {
      const selectedEmbalagem = this.itemSelected.embalagens.find((e) => e.descricao_embalagem === this.formColor.embalagem);
      const gradeColor = selectedEmbalagem.grade.dsHBIgrade.ttHBIgrade.find((item) => item.cdnCor === color.cdnCor);

      if (gradeColor) {
        this.formColor.color = gradeColor.desCor;
        this.formColor.tamanho = '';
        this.formColor.quantidade = 0;
        this.availableSizes = this.getAvailableSizes(gradeColor);
      }
    },
    repeateAgain() {
      if (!this.formColor.embalagem || !this.formColor.color || !this.formColor.tamanho || !this.formColor.quantidade) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Obrigatorio Selecionar: Embalagem, Cor, Tamanho e Quantidade.',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      if (!this.itemSelected) {
        console.error('Nenhum item selecionado');
        return;
      }

      const embalagem = this.itemSelected.embalagens.find((item) => item.descricao_embalagem === this.formColor.embalagem);

      if (embalagem.itemMultiplo !== 0) {
        const quantidade = parseInt(this.formColor.quantidade);
        if (quantidade % embalagem.itemMultiplo !== 0) {
          Swal.fire({
            icon: 'warning',
            title: 'Atenção!',
            text: `A quantidade deste item deve ser um múltiplo de ${embalagem.itemMultiplo}!`,
          });
          return;
        }
      }

      const color = embalagem.grade.dsHBIgrade.ttHBIgrade.find((item) => item.desCor === this.formColor.color);

      if (!color) {
        console.error('Color not found in grade');
        return;
      }

      const itemId = color[`item${this.formColor.tamanho}`];

      if (!itemId) {
        console.error('Item ID not found for selected size');
        return;
      }

      const hasDuplicateLocal = this.items.some((item) => item.item_id === itemId
        && item.embalagem === this.formColor.embalagem
        && item.des_cor === this.formColor.color
        && item.tamanho === this.formColor.tamanho);

      const storeItems = this.$store.getters['intensPedido/getlistarTabelaItens'] || [];
      const hasDuplicateInStore = storeItems.some((storeItem) => (storeItem.itens || []).some((subItem) => subItem.itemId === itemId
          && subItem.embalagem === this.formColor.embalagem
          && subItem.des_cor === this.formColor.color
          && subItem.desc_tamanho === this.formColor.tamanho));

      if (hasDuplicateLocal || hasDuplicateInStore) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Item Duplicado',
            text: 'Este item já foi adicionado!',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        });
        return;
      }

      const newItem = {
        referencia: this.itemSelected.referencia,
        embalagem: this.formColor.embalagem,
        cdn_embalagem: this.formColor.cdn_embalagem,
        des_cor: this.formColor.color,
        cdn_cor: color.cdnCor,
        tamanho: this.formColor.tamanho,
        item_id: itemId,
        valor: parseInt(this.formColor.quantidade, 10),
        nome: this.itemSelected.item_name,
        marca: this.itemSelected.item_marca,
        precoUnitario: parseFloat(this.itemSelected.item_price_base ?? this.itemSelected.item_price),
        valorTotal: +this.itemSelected.item_price * parseInt(this.formColor.quantidade),
        itemMultiplo: embalagem.itemMultiplo || 1,
        uniqueId: `${this.formColor.embalagem}-${this.formColor.color}-${this.formColor.tamanho}-${itemId}-${Date.now()}`,
        itens: [{
          cdncor: color.cdnCor,
          desc_tamanho: this.formColor.tamanho,
          pedidoItemQuantidade: parseInt(this.formColor.quantidade, 10),
          itemMultiplo: embalagem.itemMultiplo || 1,
          valorTotal: +this.itemSelected.item_price * parseInt(this.formColor.quantidade),
        }],
      };

      try {
        this.items = this.items.filter((item) => !(item.referencia === this.itemSelected.referencia
            && item.embalagem === this.formColor.embalagem
            && item.des_cor === this.formColor.color
            && item.tamanho === this.formColor.tamanho));

        this.items.push(newItem);
        this.$emit('update:grade', this.items.slice());
        this.formColor.quantidade = 0;
      } catch (error) {
        console.error('Erro ao adicionar item', error);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Falha',
            text: 'Erro ao adicionar item',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        });
      } finally {
        this.formColor.quantidade = 0;
      }
    },
    selecionarItem(item) {
      this.itemSelected = item;
      this.formColor = {
        embalagem: '',
        cdn_embalagem: '',
        color: '',
        tamanho: '',
        quantidade: 0,
      };
      this.availableColors = [];
      this.availableSizes = [];
      const embalagensValidas = this.getValidEmbalagens(item.embalagens);
      if (embalagensValidas.length > 0) {
        const primeiraEmbalagem = embalagensValidas[0];
        this.selectEmbalagem(primeiraEmbalagem);
      }
    },
  },
};
</script>
<style scoped>
.imagens-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.imagens-item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
}

.imagens-item-img {
  border: 1px solid var(--primary);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.imagens-item-img img {
  height: 50px;
  width: auto;
  object-fit: contain;
}

.loading-indicator {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  justify-content: center;
}

.product-color-options h6 {
  font-size: 16px;
  font-weight: 600;
}

@media (max-width: 768px) {
  .imagens-container {
    width: 100%;
    padding-bottom: 10px;
    flex-direction: row;
    justify-content: center;
  }

  .imagens-item {
    flex-direction: row;
  }

  /* Mantém rolagem horizontal para listas com muitas opções */
  .product-color-options .scrollable-pills {
    flex-direction: row;
    flex-wrap: nowrap;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .product-color-options ul li {
    width: 100%;
    text-align: center;
  }

  .product-color-options h6 {
    text-align: center;
  }

  .ecommerce-details-item_price {
    justify-content: center;
  }

  .item-item_price {
    text-align: center;
    width: 100%;
  }

  .col-md-6 {
    text-align: center;
  }

  .app-ecommerce-details .row.ml-1 {
    margin-left: 0 !important;
  }

  .imagens-container {
    flex-direction: row !important;
    justify-content: center;
    width: 100%;
  }

  .imagens-container.col-1 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }
}

/* Scroll horizontal suave para pílulas (desktop e mobile) */
.scrollable-pills {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 6px;
  scroll-snap-type: x proximity;
}
.scrollable-pills li {
  flex: 0 0 auto;
  scroll-snap-align: start;
}
.scrollable-pills::-webkit-scrollbar {
  height: 6px;
}
.scrollable-pills::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}
</style>
